import { render, staticRenderFns } from "./RefundComplete.vue?vue&type=template&id=48800c1b&scoped=true&"
import script from "./RefundComplete.vue?vue&type=script&lang=js&"
export * from "./RefundComplete.vue?vue&type=script&lang=js&"
import style0 from "./RefundComplete.vue?vue&type=style&index=0&id=48800c1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48800c1b",
  null
  
)

export default component.exports